import { Link } from "react-router-dom";
import "./MobileNav.css";

import Mercury from "../../assets/planet-mercury.svg";
import Venus from "../../assets/planet-venus.svg";
import Earth from "../../assets/planet-earth.svg";
import Mars from "../../assets/planet-venus.svg";
import Jupiter from "../../assets/planet-jupiter.svg";
import Saturn from "../../assets/planet-saturn.svg";
import Uranus from "../../assets/planet-uranus.svg";
import Neptune from "../../assets/planet-neptune.svg";

const MobileNav = (props) => {
  return (
    <div class="Mobile-nav">
      <ul className="mobile-links">
        <li onClick={props.handler}>
          <img className="menu-planet-icon" src={Mercury} />
          <Link to="/mercury">Mercury</Link>
        </li>
        <li onClick={props.handler}>
          <img className="menu-planet-icon" src={Venus} />
          <Link to="/venus">Venus</Link>
        </li>
        <li onClick={props.handler}>
          <img className="menu-planet-icon" src={Earth} />
          <Link to="/earth">Earth</Link>
        </li>
        <li onClick={props.handler}>
          <img className="menu-planet-icon" src={Mars} />
          <Link to="/mars">Mars</Link>
        </li>
        <li onClick={props.handler}>
          <img className="menu-planet-icon" src={Jupiter} />
          <Link to="/jupiter">Jupiter</Link>
        </li>
        <li onClick={props.handler}>
          <img className="menu-planet-icon" src={Saturn} />
          <Link to="/saturn">Saturn</Link>
        </li>
        <li onClick={props.handler}>
          <img className="menu-planet-icon" src={Uranus} />
          <Link to="/uranus">Uranus</Link>
        </li>
        <li onClick={props.handler}>
          <img className="menu-planet-icon" src={Neptune} />
          <Link to="/neptune">Neptune</Link>
        </li>
      </ul>
    </div>
  );
};

export default MobileNav;
